const config = {}

config.env = {
  production: process.env.NODE_ENV === 'production',
  staging: process.env.NODE_ENV === 'staging',
  development: process.env.NODE_ENV === 'development',
  desktop: process.env.NODE_PLATFORM === 'desktop',
  web: process.env.NODE_PLATFORM === 'web'
}

module.exports = config



//////////////////
// WEBPACK FOOTER
// ./config/config.base.js
// module id = 360
// module chunks = 0